import { IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';

import { Loading, Logo, Padding } from '@/components/common';
import { GOOGLE_PLAY_STORE_URL } from '@/utils/constants';

const Android: React.FC = () => {
  useEffect(() => {
    window.location.href = GOOGLE_PLAY_STORE_URL;
  }, []);

  return (
    <IonPage id="android">
      <IonContent>
        <Padding>
          <Logo />
          <Loading />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Android;
